import api from "../../../../lib/api";
import { IZoneCreate, IZoneListSearch, IEditZonePayload } from "../../../../types/master/zoneInterface";
import { toast } from "react-toastify";

export const createZoneApi = async (data: IZoneCreate) => {
  return await api.post(`/zone/`, data);
};

export const getZoneListApi = async (data: IZoneListSearch) => {
  return await api.get(`/zone/${data.page}/${data?.pageLimit}?search=${data?.search??""}`)
}

export const getZoneDataByIdApi = async (id: number) => {
  return await api.get(`/zone/view/${id}`)
}

export const editZoneDataByIdApi = async (payload: IEditZonePayload) => {
  return await api.put(`/zone/${payload.id}`, payload.data);
};

export const deleteZoneApi = async (id: number) => {
  return await api.delete(`/zone/${id}`);
};

export const checkZoneAvailabilityApi = async (payload: { zone: string, signal?: any }) => {
  try {
    const {data} = await api.get(`/zone/available/?zone=${payload.zone}`, {
      signal: payload.signal
    });
    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      return true;
    }
  } catch (error: any) {
    if (error.code === "ERR_BAD_REQUEST") {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
      });
    }
    return false;
  }
};
// export const checkZoneAvailabilityApi = async (payload:{zone: string, signal?: any}) => {
//   return await api.get(`/zone/available/?zone=${payload.zone}`, {
//     signal: payload.signal
//   })
// }